import React from 'react'
import { FaPaperclip } from 'react-icons/fa'

const ATTACHMENT_EXEMPT_ICON_OPACITY = 0.4

type AttachmentExemptIconProps = React.ComponentProps<typeof FaPaperclip>

export const AttachmentExemptIcon: React.FC<AttachmentExemptIconProps> = ({
  opacity = ATTACHMENT_EXEMPT_ICON_OPACITY,
  ...props
}) => <FaPaperclip opacity={opacity} {...props} />
